import MeetingLinkView from "@/sections/LinkFlow/LinkMeetingView";
import SimulInterImg from '@/assets/simulInter/simul_inter.png'
import { useRef, useState } from "react";
import IPConnectModal, { IPConnectModalRef } from "./components/IPConnectModal";
import { message } from "antd";
import deviceStore from "@/store/device.store";
import EasyLoading from "@/component/EasyLoading";

const LinkView = ({ streamName, onConnectSuccess, loading }: { streamName: string, onConnectSuccess: (isStart: boolean, streamName?: string) => void, loading?: boolean }) => {
  const ipConnectModalRef = useRef<IPConnectModalRef>(null);
  const [localConnectLoading, setLocalConnectLoading] = useState(false);
  const allowLocalConnect = localStorage.getItem("allowLocalConnect") === "true";

  const handleConnectIpAddress = () => {
    ipConnectModalRef.current?.open();
  };

  const handleConnectLocal = async () => {
    const trimmedIp = '127.0.0.1';
    const port = '2998';
    setLocalConnectLoading(true);
    console.log(`尝试连接本地设备`);

    // 使用通用连接方法
    const result = await deviceStore.getState().connectDeviceByIP(trimmedIp, port);
    if (!result.success) {
      message.error(result.errorMsg || "连接失败，请检查网络后重试");
      setLocalConnectLoading(false);
      return;
    }

    // 回调通知父组件
    onConnectSuccess && onConnectSuccess(
      result.isRecording || false,
      result.streamName
    );
    setLocalConnectLoading(false);
  };

  return (
    <div className="relative flex flex-col justify-center items-center flex-1 bg-gradient-to-b from-#FFF5 to-#FFF3 rounded-2 border-1px border-solid border-#FFF ">
      <EasyLoading isShow={localConnectLoading} />
      <img src={SimulInterImg} className="w-75 h-42.5 mt-27" />
      <div className="mt-6 text-center">
        <div className="font-600 text-mx-secondary text-4.5 lh-6">
          连接设备，加入/启动会议录制
        </div>
        <div className="text-#626773CC/80 mt-2 text-size-3.5">请确保连接设备在同一网络下</div>
      </div>
      <MeetingLinkView linkType="ControlLink" showTips={false} onConnectSuccess={onConnectSuccess} loading={loading} />
      <div className="absolute bottom-5 flex text-center text-3 text-mx-primary">
        <span className="cursor-pointer" onClick={handleConnectIpAddress}>使用IP地址连接</span>
        {allowLocalConnect && <span className="ml-2 cursor-pointer" onClick={handleConnectLocal}>本地连接</span>}
      </div>
      <IPConnectModal ref={ipConnectModalRef} streamName={streamName} onConnectSuccess={onConnectSuccess} />
    </div>
  );
};

export default LinkView;
